import { IoCheckmarkCircle } from "react-icons/io5";
import Dragger from "antd/es/upload/Dragger.js";
import { useResponsive } from "../../hooks/useResponsive.js";

const KycVerified = ({ kycDetails }) => {
  const { isMobile } = useResponsive();

  const isPdfFile = (url) => url?.toLowerCase().endsWith(".pdf");

  const openPdf = (url) => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="w-full flex flex-col items-center justify-center py-10 gap-8 overflow-scroll">
      <div className="flex flex-col items-center text-center px-6 py-10 rounded-xl max-w-md mx-auto">
        <IoCheckmarkCircle className="text-green-600 w-20 h-20 mb-8" />
        <h2 className="text-3xl font-bold mb-3">Your KYC is Verified</h2>
        <p className="text-gray text-base">
          Thank you! Your documents are verified and your account is now fully
          secure.
        </p>
      </div>

      {kycDetails && (
        <div
          className={`flex overflow-scroll flex-wrap ${
            isMobile ? "flex-col" : "flex-row"
          } gap-3 w-full max-w-6xl`}
        >
          {/* ID Proof Section */}
          <div className="border border-gray-300 rounded-md p-5 flex-1">
            <p className="text-[#2F2B3D] text-2xl text-center mb-3">ID Proof</p>
            <p className="text-gray-500 text-base text-center mb-3">
              Uploaded documents
            </p>

            <div className="flex md:flex-nowrap flex-wrap lg:gap-6 gap-3 justify-center">
              {/* Front Side */}
              <div className="mb-3">
                <Dragger
                  disabled={true}
                  showUploadList={false}
                  beforeUpload={() => false}
                  className="front-upload"
                >
                  <div className="w-full h-full">
                    {kycDetails?.fileUrlPath?.[0] ? (
                      <div className="relative flex justify-center items-center">
                        {isPdfFile(kycDetails.fileUrlPath[0]) ? (
                          <div className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] bg-gray-100 flex flex-col items-center justify-center text-gray-700 gap-2">
                            PDF
                            <button
                              type="button"
                              className="text-primary underline text-sm"
                              onClick={(e) => {
                                e.stopPropagation();
                                openPdf(kycDetails.fileUrlPath[0]);
                              }}
                            >
                              View PDF
                            </button>
                          </div>
                        ) : (
                          <img
                            src={kycDetails.fileUrlPath[0]}
                            alt="front"
                            className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] object-contain"
                          />
                        )}
                      </div>
                    ) : (
                      <div className="flex justify-center flex-col items-center md:py-4 md:px-5">
                        <p className="text-gray-400">
                          Front side not available
                        </p>
                      </div>
                    )}
                  </div>
                </Dragger>
              </div>

              {/* Back Side */}
              <div className="mb-3">
                <Dragger
                  disabled={true}
                  showUploadList={false}
                  beforeUpload={() => false}
                  className="back-upload"
                >
                  <div className="w-full h-full">
                    {kycDetails?.fileUrlPath?.[1] ? (
                      <div className="relative flex justify-center items-center">
                        {isPdfFile(kycDetails.fileUrlPath[1]) ? (
                          <div className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] bg-gray-100 flex flex-col items-center justify-center text-gray-700 gap-2">
                            PDF
                            <button
                              type="button"
                              className="text-primary underline text-sm"
                              onClick={(e) => {
                                e.stopPropagation();
                                openPdf(kycDetails.fileUrlPath[1]);
                              }}
                            >
                              View PDF
                            </button>
                          </div>
                        ) : (
                          <img
                            src={kycDetails.fileUrlPath[1]}
                            alt="back"
                            className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] object-contain"
                          />
                        )}
                      </div>
                    ) : (
                      <div className="flex justify-center flex-col items-center md:py-4 md:px-5">
                        <p className="text-gray-400">Back side not available</p>
                      </div>
                    )}
                  </div>
                </Dragger>
              </div>
            </div>
          </div>

          {/* Address Proof Section */}
          <div className="border border-gray-300 rounded-md p-5 flex-1">
            <p className="text-[#2F2B3D] text-2xl text-center mb-3">
              Address Proof
            </p>
            <p className="text-gray-500 text-base text-center mb-3">
              Uploaded documents
            </p>

            <div className="flex md:flex-nowrap flex-wrap lg:gap-6 gap-3 justify-center">
              {/* Front Side */}
              <div className="mb-3">
                <Dragger
                  disabled={true}
                  showUploadList={false}
                  beforeUpload={() => false}
                  className="address-proof-front-upload"
                >
                  <div className="w-full h-full">
                    {kycDetails?.addressUrlPath?.[0] ? (
                      <div className="relative flex justify-center items-center">
                        {isPdfFile(kycDetails.addressUrlPath[0]) ? (
                          <div className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] bg-gray-100 flex flex-col items-center justify-center text-gray-700 gap-2">
                            PDF
                            <button
                              type="button"
                              className="text-primary underline text-sm"
                              onClick={(e) => {
                                e.stopPropagation();
                                openPdf(kycDetails.addressUrlPath[0]);
                              }}
                            >
                              View PDF
                            </button>
                          </div>
                        ) : (
                          <img
                            src={kycDetails.addressUrlPath[0]}
                            alt="address-proof-front"
                            className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] object-contain"
                          />
                        )}
                      </div>
                    ) : (
                      <div className="flex justify-center flex-col items-center md:py-4 md:px-5">
                        <p className="text-gray-400">
                          Front side not available
                        </p>
                      </div>
                    )}
                  </div>
                </Dragger>
              </div>

              {/* Back Side */}
              <div className="mb-3">
                <Dragger
                  disabled={true}
                  showUploadList={false}
                  beforeUpload={() => false}
                  className="address-proof-back-upload"
                >
                  <div className="w-full h-full">
                    {kycDetails?.addressUrlPath?.[1] ? (
                      <div className="relative flex justify-center items-center">
                        {isPdfFile(kycDetails.addressUrlPath[1]) ? (
                          <div className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] bg-gray-100 flex flex-col items-center justify-center text-gray-700 gap-2">
                            PDF
                            <button
                              type="button"
                              className="text-primary underline text-sm"
                              onClick={(e) => {
                                e.stopPropagation();
                                openPdf(kycDetails.addressUrlPath[1]);
                              }}
                            >
                              View PDF
                            </button>
                          </div>
                        ) : (
                          <img
                            src={kycDetails.addressUrlPath[1]}
                            alt="address-proof-back"
                            className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] object-contain"
                          />
                        )}
                      </div>
                    ) : (
                      <div className="flex justify-center flex-col items-center md:py-4 md:px-5">
                        <p className="text-gray-400">Back side not available</p>
                      </div>
                    )}
                  </div>
                </Dragger>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KycVerified;
